import { addressEllipsis } from "@osn/common";
import { normalizeAddress } from "./normalizeAddress";
import { bigNumberToLocaleString } from "./viewFuncs";
import BigNumber from "bignumber.js";

export function formatAddress(address, ellipsis = true) {
  if (!address) return "";

  const normalized = normalizeAddress(address);
  return ellipsis ? addressEllipsis(normalized) : normalized;
}

export function formatBalance(balance, decimals = 12) {
  if (!balance) return "0";

  try {
    const balanceBN = new BigNumber(balance);
    const divisor = new BigNumber(10).pow(decimals);
    const formatted = balanceBN.div(divisor);

    return bigNumberToLocaleString(formatted.toString());
  } catch (error) {
    console.error("Error formatting balance:", error);
    return balance.toString();
  }
}
